/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the thumbnail of any YouTube Short. Paste a Shorts link to grab the cover image in every available resolution. Free, no signup.`)
};

const es_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga la miniatura de cualquier YouTube Short. Pega el enlace del Short para obtener la imagen de portada en todas las resoluciones disponibles. Gratis, sin registro.`)
};

const de_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade das Thumbnail jedes YouTube Shorts. Füge den Shorts-Link ein und hol dir das Titelbild in jeder Auflösung. Kostenlos, keine Anmeldung.`)
};

const nl_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download de thumbnail van elke YouTube Short. Plak een Shorts-link om de cover-afbeelding in elke resolutie te downloaden. Gratis, geen account nodig.`)
};

const fr_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez la miniature de n’importe quel YouTube Short. Collez un lien Shorts pour récupérer l’image de couverture. Gratuit, sans inscription.`)
};

const it_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica la miniatura di qualsiasi YouTube Short. Incolla un link Shorts per ottenere l'immagine di copertina in ogni risoluzione disponibile. Gratis, senza registrazione.`)
};

const pt_br2_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe a thumbnail de qualquer YouTube Short. Cole um link de Shorts para pegar a imagem de capa em todas as resoluções disponíveis. Grátis, sem cadastro.`)
};

const pt_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregue a miniatura de qualquer YouTube Short. Cole um link de Shorts para obter a imagem de capa em todas as resoluções disponíveis. Grátis, sem registo.`)
};

const ja_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のYouTube Shortsのサムネイルをダウンロード。Shortsのリンクを貼り付けるだけで、利用可能なすべての解像度でカバー画像を取得できます。無料、登録不要。`)
};

const zh_yt_shorts_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载任意 YouTube Short 的缩略图。粘贴 Shorts 链接，获取所有可用分辨率的封面图片。免费，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_meta_description", locale)
	if (locale === "en") return en_yt_shorts_meta_description(inputs)
	if (locale === "es") return es_yt_shorts_meta_description(inputs)
	if (locale === "de") return de_yt_shorts_meta_description(inputs)
	if (locale === "nl") return nl_yt_shorts_meta_description(inputs)
	if (locale === "fr") return fr_yt_shorts_meta_description(inputs)
	if (locale === "it") return it_yt_shorts_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_meta_description(inputs)
	if (locale === "pt") return pt_yt_shorts_meta_description(inputs)
	if (locale === "ja") return ja_yt_shorts_meta_description(inputs)
	return zh_yt_shorts_meta_description(inputs)
};